module.exports = __webpack_public_path__ + "static/media/service_active.2f4d3611.png";